import { setPartnerWidgetId } from '@/context/display';
import { store } from '@/context/store';

export function setInitialWidgetId(widgetId: string | null): void {
    if (!widgetId) return;
    store.dispatch(setPartnerWidgetId(widgetId));
}
